module.exports = __webpack_public_path__ + "static/img/014.ac15fd14.png";